var _a;
import React from 'react';
import { injectIntl } from 'react-intl';
import styled from 'styled-components';
import { connect } from 'react-redux';
import * as ContentMargin from '@commoncomponents/frontend-components/dist/components/ContentMargin';
import * as ModalModule from '@commoncomponents/frontend-components/dist/components/ModalRoot/components';
import * as Button from '@commoncomponents/frontend-components/dist/components/Buttons';
import * as Text from '@commoncomponents/frontend-components/dist/components/Text';
import Divider from '@commoncomponents/frontend-components/dist/components/Divider';
import { Standard as StandardLink } from '@commoncomponents/frontend-components/dist/components/Link';
import { IconAdd } from '@commoncomponents/frontend-components/dist/components/Icons/Icons';
import { breakpoints } from '@commoncomponents/frontend-components/dist/styled';
import CodeActivationData from './CodeActivationData';
const illustrationSuccess = (_a = require('./illustrations/illustrationSuccess.svg')) === null || _a === void 0 ? void 0 : _a.default;
const CodeActivationSuccessModal = ({ intl: { formatMessage }, organizationCodeUser, newPlanInfo, onClose, onAddAnotherCodeButtonClick, translations: { header, activatedPlanDataLabel, expirationText, userDataLabel, addAnotherCodeButtonText, closeButtonText, youText, }, currentUserEmail, isMobileView, }) => {
    return (React.createElement(ModalWrapper, null,
        React.createElement(ContentMargin.Custom, { size: isMobileView ? [3, 2] : [3, 4] },
            React.createElement(ModalModule.Title, { variant: "center", onClose: onClose },
                React.createElement(ContentMargin.Top, { size: isMobileView ? 0 : 2 },
                    React.createElement("img", { src: illustrationSuccess, alt: "Illustration success", width: "100px" })))),
        React.createElement(ContentMargin.OX, { size: isMobileView ? 2 : 4 },
            React.createElement(ModalModule.Content, null,
                React.createElement(Text.Subheading1, null, header &&
                    formatMessage(header.text, {
                        planName: newPlanInfo.name,
                    })),
                React.createElement(ContentMargin.Custom, { size: isMobileView ? [3, 0, 1] : [3, 0, 3] },
                    React.createElement(CodeActivationData, { userFullName: `${organizationCodeUser.givenName} ${organizationCodeUser.surname} `, userEmail: organizationCodeUser.boxIdentifier, activatedPlanDataLabel: activatedPlanDataLabel, expirationText: expirationText, userDataLabel: userDataLabel, youText: youText, isCurrentUser: organizationCodeUser.boxIdentifier === currentUserEmail, newPlanInfo: newPlanInfo })))),
        !isMobileView && React.createElement(Divider, null),
        React.createElement(ContentMargin.Custom, { size: isMobileView ? [2, 2] : [2, 4] },
            React.createElement(ButtonsWrapper, null,
                React.createElement(StandardLink, { onClick: onAddAnotherCodeButtonClick },
                    React.createElement(TextWithIconWrapper, null,
                        React.createElement(IconAdd, { width: "16px", height: "16px" }),
                        addAnotherCodeButtonText)),
                React.createElement(Button.PrimaryRounded, { label: closeButtonText, onClick: onClose })))));
};
const ModalWrapper = styled.div `
  @media (min-width: 769px) {
    min-width: 560px;
  }
  @media (max-width: 768px) {
    .modal--title__closeIcon {
      svg {
        height: 26px;
        width: 26px;
      }
    }
  }
`;
const ButtonsWrapper = styled.div `
  align-items: center;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  button {
    margin-left: 20px;
  }
  @media ${breakpoints.md} {
    flex-direction: column-reverse;
    button {
      margin: 0 0 20px;
      width: 100%;
    }
  }
`;
const TextWithIconWrapper = styled.div `
  align-items: center;
  display: inline-flex;
  svg {
    margin-right: 6px;
  }
`;
export const mapStateToProps = (state) => ({
    organizationCodeUser: state.organizationActivationCodes.get('user'),
    newPlanInfo: state.organizationActivationCodes.get('newPlanInfo'),
});
export default connect(mapStateToProps, null)(injectIntl(CodeActivationSuccessModal));
